import { Component, OnInit } from '@angular/core';
import { Select, Select$, NgRedux } from '@angular-redux3/store';
import { SwUpdate, UpdateAvailableEvent } from '@angular/service-worker';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PlaylistRemoteAppState, ALogout } from '../../store';
import { Playlist } from './../../store/entities';
import { toArray } from '../../utils';

@Component({
  selector: 'mwo-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsPage implements OnInit {
  @Select$(['playlists', 'events'], toArray) playlists$: Observable<Playlist[]>;
  // @ts-ignore
  trackCount$: Observable<number> = this.playlists$.pipe(
    map<Playlist[], number>(events => events.reduce((acc, event) =>
      acc + event.assoMediaEvent?.length ? event.assoMediaEvent?.length : 0, 0))
  );
  @Select(['resort', 'name']) resortName$: Observable<string>;
  @Select(['remote', 'name']) place$: Observable<string>;
  lastUpdate: string;

  availableTracks = 0;
  update$: Observable<UpdateAvailableEvent>;

  constructor(
    private updates: SwUpdate,
    private ngRedux: NgRedux<PlaylistRemoteAppState>
  ) { }

  ngOnInit() {
    if ('serviceWorker' in navigator) {
      this.update$ = this.updates.available;
    }
  }

  async reload(): Promise<void> {
    if ('serviceWorker' in navigator) {
      await this.updates.activateUpdate();
    }
    document.location.reload();
  }

  logout() {
    this.ngRedux.dispatch(ALogout());
  }

  quit(): void {
    window.close();
  }
}
